import React from 'react';
import { Link } from 'react-router-dom';

import { useTranslation } from '@common/hooks/translation';
import { SkinImage } from '@app/dev/terminal/components/skinImage';

import './style.scss';
import Config from '@app/dev/config/main';

const FavoriteCompetitions = () => {
  const t = useTranslation();

  return (
    <div className="home-favorite-competitions">
      {Config.main.homeFavoritCompetitions.map((comp, index) => (
        <Link key={index} to={comp.url}>
          <SkinImage
            className="comp-bg-image"
            path={`favoriteCompetitions/fav-comp-${index + 1}.${comp.fileType || 'png'}`}
            fileType={comp.fileType}
          />
          <p className={comp.classname} />
          {t(comp.name)}
        </Link>
      ))}
    </div>
  );
};

export default FavoriteCompetitions;
